import {create, StateCreator} from 'zustand';
import {FitbItemBankStore, initialState} from './types';
import actions from './actions';
import {devtools} from 'zustand/middleware';
import {immer} from 'zustand/middleware/immer';

const fitbItemBankStore: StateCreator<
  FitbItemBankStore,
  [['zustand/devtools', never], ['zustand/immer', never]]
> = (set, get) => ({
  ...initialState,
  ...actions(set, get)
});

export const useFitbItemBankStore = create<FitbItemBankStore>()(
  devtools(immer(fitbItemBankStore), {name: 'fitb-item-bank'})
);

export const createUseItemBankStoreInstance = () => useFitbItemBankStore;
export * from './types';
export * from './actions';
